import { Fragment, useState, useCallback, useEffect } from "react";
import RecurringTransactionCard from "../cards/finances/RecurringTransactionCard";
import RecurringDetailsModal from "../popup/finances/RecurringDetailsModal";
import { mapRecurringTransactionToRow } from "../popup/finances/utils/helpers";
import { getRecurringTransactions } from "../../../api/finances/recurringTransactionsAPI";
import GhostTransactionsCarousel from "../loading/skeletons/GhostTransactionCarousel";
import BaseCarousel from "./common/BaseCarousel";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../utils/schemas/language/pages/personalFinancesSchema";

function RecurrentTransactionCarousel() {
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const fetchUpcoming = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await getRecurringTransactions({
        upcoming: true,
        limit: 6,
      });
      const mapped = Array.isArray(data?.upcoming)
        ? data.upcoming.map(mapRecurringTransactionToRow)
        : [];
      setRows(mapped);
    } catch (error) {
      console.error("Failed to fetch upcoming transactions", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUpcoming();
  }, [fetchUpcoming]);

  const handleTransactionUpdate = (updatedTransaction) => {
    setSelectedTransaction(updatedTransaction);
    setRows((currentRows) =>
      currentRows.map((row) =>
        row.uuid === updatedTransaction.uuid
          ? { ...row, ...updatedTransaction }
          : row,
      ),
    );
  };

  return (
    <Fragment>
      <BaseCarousel
        title={content.overview.upcoming_transactions.title}
        seeAllPath="/finances/personal-finances/recurring-transactions"
        seeAllText={content.global.see_all}
        items={rows}
        isLoading={isLoading}
        emptyMsg={content.overview.upcoming_transactions.empty}
        previousAlt={content.global.previous}
        nextAlt={content.global.next}
        GhostComponent={
          <GhostTransactionsCarousel count={3} showPagination={false} />
        }
        renderItem={(item, index) => (
          <RecurringTransactionCard
            key={item.uuid || index}
            transaction={item}
            onClick={() => setSelectedTransaction(item)}
          />
        )}
      />

      {selectedTransaction && (
        <RecurringDetailsModal
          transaction={selectedTransaction}
          onTransactionUpdate={handleTransactionUpdate}
          copy={content.recurring.details}
          commonCopy={content.global}
          onClose={() => setSelectedTransaction(null)}
        />
      )}
    </Fragment>
  );
}

export default RecurrentTransactionCarousel;
